import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";

//モーダルをインポート
import { 
  ComprehensiveOptionDetailsModal,
} from "./../../modal"

//scss
import "../../../scss/common.scss";
import "../../../scss/component.scss";

import { IActivity } from "../../../types/Activity";
import LoadingOverlay from 'react-loading-overlay-ts';
import {PlanSearch} from "../../../types/Search";
import {
  checkActivityStockExist,
  getPlanAgeConfig, getPlanConfig,
  getPlanPeopleNum, getPlanSelectPeopleType,
  getPlanStocks,
  isPlanPriceType,
  isPlanTimeStocks
} from "../../../utils/plan";
import {dateFormat} from "../../../utils/convert";
import {PlanSelectFormData} from "../../../types/planSelectForm";
import axios from "axios";
import SearchNotFound from "../../SearchNotFound";
import SectionRetry from "../../SectionRetry";
import dayjs from "dayjs";

type Props = {
    activityStockExist : boolean,
    setActivityStockExist: (value: boolean) => void,
    activities: IActivity[]
    isLoading: boolean,
    searchParams: PlanSearch,
    setActivities: ( avts: IActivity[] ) => void,
    planSelectFormData: PlanSelectFormData,
    /** `/plan` が上流障害で取れなかったとき（issue #2992 / 報告書 §8 No.4） */
    planError?: {retryAfterSec: number},
    /** 基本プラン区画だけを再要求する（ページ全体を再読み込みしない） */
    onRetryPlan?: () => void
}

const SectionPlan: React.FC<Props> = ({
  activityStockExist,
  setActivityStockExist,
  activities,
  searchParams,
  isLoading,
  setActivities,
  planSelectFormData,
  planError,
  onRetryPlan
}) => {
  const { t, i18n } = useTranslation();

  /**
   * 在庫カレンダー（/plan/stocks）が上流障害で取れなかったとき。 issue #2992 / 報告書 §8 No.4
   * ★従来は無言で欠落し「受付終了」と同じ見え方になっていた。
   */
  const [stockError, setStockError] = React.useState<{retryAfterSec: number} | undefined>(undefined);

  const [selectDate, setSelectDate] = React.useState("");

  const [images, setImages] = React.useState<string[]>();

  //-------------------------------------------------
  //　モーダルの処理
  //-------------------------------------------------
  //モーダル初期表示ページを設定
  const [step, setStep] = React.useState(1);
  const stepHandle = (step: number) => {
    setStep(step)
  }
  
  const [loading, setLoading] = React.useState(true);
  const [activityData, setActivityData] = React.useState<IActivity[]>(activities);
  const [activityStocks, setActivityStocks] = React.useState();
  
  
  // 変更確認を選んだアクティビティ
  const [currentActivity, setActivity] = React.useState<IActivity>();

  // モーダルのステータスを追加する
  const [comprehensiveOptionDetailsModal1, setComprehensiveOptionDetailsModal1] = React.useState(false);
  const [comprehensiveOptionDetailsModal2, setComprehensiveOptionDetailsModal2] = React.useState(false);

  // モーダルのhandleを追加する
  const handleComprehensiveOptionDetailsModal1 = (data:IActivity) => {
    setStep(1)
    setComprehensiveOptionDetailsModal1(!comprehensiveOptionDetailsModal1)
    setActivity(data)
  }

  const handleComprehensiveOptionDetailsModal2 = (data:IActivity) => {
    setStep(2)
    setComprehensiveOptionDetailsModal2(!comprehensiveOptionDetailsModal2)
    setActivity(data)
  }

  const selectedCallback = (data:IActivity | undefined) => {
    setLoading(false);
    setComprehensiveOptionDetailsModal1(false);
    setComprehensiveOptionDetailsModal2(false);

    if(data) {
      // 一覧を更新する
      const activityIndex = activities.findIndex((activityData) => activityData?.plan_info.plan_code === data.plan_info.plan_code)
      const planConfig = getPlanConfig(planSelectFormData.sellerProduct?.comprehensiveItems, data.plan_info.plan_code);
      activities[activityIndex].active = true;
      activities[activityIndex].date = data.date;
      activities[activityIndex].time = data.time;
      activities[activityIndex].time_code = data.time_code;
      activities[activityIndex].price_list = data.price_list;
      if (planConfig) {
        activities[activityIndex].oldmin = planConfig.oldmin;
        activities[activityIndex].oldmax = planConfig.oldmax;
        activities[activityIndex].priceType = planConfig.group;
        activities[activityIndex].isAlertActive = planConfig.isAlertActive ?? "";
        activities[activityIndex].alertTime = planConfig.alertTime ?? "";
      }
      setSelectDate(dateFormat(data.date, t("YYYY年MM月DD日"), i18n.language));
      setActivityData(activities);
      setActivities([...activities]);
    }
  }
  
  useEffect(() => {
    if (!loading) {
      return;
    }

    const activitiesData:IActivity[] = activities;

    // 基本プランが0件の場合、ローディングを解除して在庫なしを通知
    if (activities == null || activities.length === 0) {
      setActivityStockExist(false);
      setLoading(false);
      return;
    }

    if (activities !== undefined && activitiesData.length > 0) {
      setLoading(false);
      ( async () => {
        for (const [index, activity] of activitiesData.entries()) {
          activitiesData[index].loading = true;
          const planCode = activity.plan_info.plan_code;
          const selectPeopleType = getPlanSelectPeopleType(activity, planSelectFormData.planData?.product?.comprehensiveItems);
          const planStocks = await getPlanStocks(searchParams, planCode, i18n.language);
          // ★取得できなかった日付がある場合は区画エラーを立てる（issue #2992 / 報告書 §8 No.4）。
          //   「在庫なし」と「取得できなかった」を同じ見え方にしない。
          if ((planStocks.errors?.length ?? 0) > 0) {
            setStockError({retryAfterSec: planStocks.retryAfterSec ?? 0});
          }
          if (planStocks.stock) {
            
            activitiesData[index].stocks = planStocks.detail;
            const isPlanPrice = isPlanPriceType(planSelectFormData, activity);
            if (!isPlanPrice || !isPlanTimeStocks(planSelectFormData, activity, planStocks)) {
              activitiesData[index].stock = false;
            } else {
              activitiesData[index].stock = planStocks.stock;
            }
          }
          activitiesData[index].selectPeopleType = selectPeopleType;
          activitiesData[index].loading = false;
          setActivityData([...activitiesData]);
        }
        setActivities([...activitiesData]);
        
        setLoading(false);
      })();
    }
    
  },[activities, loading])

  /**
   * 在庫カレンダーだけを再要求する（issue #2992 / 報告書 §8 No.4）。
   * ★ページ全体を読み直さない。loading を立て直すと上の useEffect が
   *   同じプランの /plan/stocks だけを引き直す。
   */
  const retryStocks = () => {
    setStockError(undefined);
    setLoading(true);
  };

  //------------------------------------------------------------------
  // ★`/plan` が全件失敗した（取れたプランが 1 件も無い）場合だけ、この区画をエラー表示にする。
  //   **部分成功（取れた分がある）なら一覧は出す**（2026-09-03 レビュー §1-3）。
  //   以前は planError があると取れた分ごと隠していた。
  if (planError && activities.length === 0) {
    return (
      <section>
        <div className="wrap-content-900">
          <h2 className="heading-2 mb-24-md">{t("基本プランの日程選択")}</h2>
          <SectionRetry
            retryAfterSec={planError.retryAfterSec}
            isLoading={isLoading}
            onRetry={() => onRetryPlan?.()}
            message={t("基本プランを取得できませんでした。") ?? undefined}
          />
        </div>
      </section>
    );
  }

  return (
    <>
      <section>
        {/*
          * ★「選択できるプランが無い」ときでも、取得に失敗しているなら
          *   「在庫なし」ではなく再試行を出す（§1-3）。
          *   在庫なしを出すと再試行の手段が消え、利用者はページごと再読み込みするしかなくなる。
          */}
        {!loading && !activityStockExist && !planError
          ? <><SearchNotFound></SearchNotFound></>
          : <>
            <div className="wrap-content-900">
              <h2 className="heading-2 mb-24-md">{t("基本プランの日程選択")}</h2>
              {/* 一部のプランが取れなかった場合。取れた分は下に出したまま案内する（§1-3） */}
              {planError && (
                <SectionRetry
                  retryAfterSec={planError.retryAfterSec}
                  isLoading={isLoading}
                  onRetry={() => onRetryPlan?.()}
                  message={t("一部の基本プランを取得できませんでした。") ?? undefined}
                />
              )}
              <p className="fz-14 fz-16-md fw-b mb-10 mb-20-md">
                {t("旅行代金には下記の基本プランの料金が含まれています。まずは、プランの日程を確定してください。")}
              </p>

              <div className="box-plan-bt_gray">
                <LoadingOverlay active={loading} spinner>
                  <ul className="box-plan-bt_gray-list">
                    {
                      loading ? <div className="pb-100"></div>
                      : activityData.length > 0 ?
                        activityData.map((data: IActivity, index: any) => (
                          <li key={"boxplan"+index} className="box-plan-bt_gray-list-item">
                            <div className="box-plan-bt_gray-list-item-content">
                              <div className="box-plan-bt_gray-list-item-content-description">
                                <div className="box-plan-bt_gray-list-item-content-description-thumbnail large">
                                  <img src={data.plan_info.image_list[0].image_url} alt="" />
                                </div>
                                <div className="box-plan-bt_gray-list-item-content-description-text">
                                  <p className="mb-5">
                                    <span className="label-orange">
                                      <i className="icon-flag-orange mr-5"></i>{t("プラン")}{index + 1}
                                    </span>
                                  </p>
                                  <p className="fz-16 fw-b lh-1_4">{data?.plan_info?.plan_name}</p>
                                </div>
                              </div>

                                  {
                                    data.active === true ? (
                                      <>
                                        <div className="box-plan-bt_gray-list-item-content-status">
                                          <div className="d-f d-b-md jc-sb ai-c fx-1">
                                            <p className="mb-10-md ta-c fz-14 fw-b">
                                              {dayjs(data.date).format(t('YYYY年MM月DD日') ?? "YYYY年MM月DD日")} <br className="d-n d-b-md" />
                                              {data.time && data.time !== 'no_settime' && (<>{data.time}</>)}
                                            </p>
                                            {data.stock && (
                                              <p className="pl-2-md pr-2-md">
                                                <button
                                                  className="button-border-medium w-100per"
                                                  onClick={() => handleComprehensiveOptionDetailsModal2(data)}
                                                >
                                                  {t("変更する")}
                                                </button>
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </>
                                    )
                                    : data.stock ? (
                                      <div className="box-plan-bt_gray-list-item-content-status">
                                        <div className="d-f d-b-md jc-sb ai-c fx-1">
                                          <p className="pl-2-md pr-2-md fx-1">
                                            <button
                                              onClick={() => handleComprehensiveOptionDetailsModal1(data)}
                                              className="button-medium-orange padding-large w-100per"
                                            >
                                              {t("日程を選択する")}
                                            </button>
                                          </p>
                                        </div>
                                      </div>
                                    )
                                    : data.loading || data.loading === undefined ?
                                      <LoadingOverlay active={true} spinner>
                                      <div className="box-plan-bt_gray-list-item-content-status">
                                        <div className="d-f d-b-md jc-sb ai-c fx-1">
                                        </div>
                                      </div>
                                      </LoadingOverlay>
                                    : (
                                        <div className="box-plan-bt_gray-list-item-content-status">
                                          <div className="d-f d-b-md jc-sb ai-c fx-1">
                                            <span className="button-medium-disabled w-100per">{t("受付終了")}</span>
                                          </div>
                                        </div>
                                      )
                                  }
                            </div>
                          </li>
                        ))
                      : t("基本プランが見つかりませんでした。")
                    }
                  </ul>
                  {/* 在庫カレンダーの一部が取得できなかった場合（issue #2992 / 報告書 §8 No.4） */}
                  {stockError && !loading && (
                    <SectionRetry
                      retryAfterSec={stockError.retryAfterSec}
                      isLoading={loading}
                      onRetry={retryStocks}
                      message={t("空き状況を取得できませんでした。") ?? undefined}
                    />
                  )}
                </LoadingOverlay>
              </div>
            </div>
          </>
        }
      </section>
      
      {/* STEP1 */}
      <ComprehensiveOptionDetailsModal planSelectFormData={planSelectFormData} activity={currentActivity} stepHandler={stepHandle} defaultStep={step} isShow={comprehensiveOptionDetailsModal1} callback={selectedCallback} />
      {/* STEP2 */}
      <ComprehensiveOptionDetailsModal planSelectFormData={planSelectFormData} activity={currentActivity} stepHandler={stepHandle} defaultStep={step} isShow={comprehensiveOptionDetailsModal2} callback={selectedCallback} />
    </>
  );
};

export default SectionPlan;
